import React, { useState } from "react";
import BaseButton from "../base/BaseButton";
import GreenRightIcon from "../../assets/img/GreenRightIcon.svg";
import EmptyResult from "./EmptyResult";
import Spinner from "../base/Spinner";
import BaseStatusLabel from "../base/BaseStatusLabel";
import DownloadIcon from "../../assets/icons/downloadIcon.svg";
import GreenDotIcon from "../../assets/img/GreenDotIcon.svg";
import ViewResultModal from "./ViewResultModal";
import moment from "moment";
const OrganisationDashboardResult = ({
    handleShowModal,
    order
}: {
    handleShowModal: any;
    order: any;
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [show, setShow] = useState(false);
    const [resultUrl, setResultUrl] = useState("");
    const viewResult = (url: any) => {
        setShow(!show);
        setResultUrl(url);
    };

    const handleDownload = (url: any) => {
        fetch(
            `https://healthtracka-s3-bucket.s3.eu-west-2.amazonaws.com/${url}`
        )
            .then((response) => response.blob())
            .then((blob) => {
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = "result";
                document.body.appendChild(a);
                a.click();
                a.remove();
            })
            .catch(() => {
                console.error("Error downloading file.");
            });
    };
    return (
        <>
            <div className="bg-white absolute z-[1000] min-h-screen bottom-0 top-0 left-0 right-0 py-10 px-6">
                <BaseButton
                    text="Return"
                    variant="neutral"
                    hasLeftIcon={true}
                    styles=" !text-[#35946D] px-4 font-[500] xl:!px-8"
                    click={handleShowModal}
                >
                    <img
                        src={GreenRightIcon}
                        alt="download"
                        className="w-[24px] ml-2 rotate-180"
                    />
                </BaseButton>
                <div className="bg-[#F2F6FA] mt-10 p-3">
                    <div className="mb-4 md:flex md:gap-2 md:items-center ">
                        <p className="text-[#0C4654] mb-1">
                            Order Results for{" "}
                            <span className="font-medium">
                                {" "}
                                {order?.user.lastName} {order?.user.firstName}{" "}
                                ORD
                                {order?.id}
                            </span>{" "}
                        </p>
                        <div className="w-[max]">
                            <BaseStatusLabel status={order?.status} />
                        </div>
                    </div>
                    {order?.uploadedPdfResults?.length <= 0 ? (
                        <EmptyResult />
                    ) : (
                        order?.uploadedPdfResults.map(
                            (uploadedPdfResult: any) => (
                                <div className="hover:bg-slate-50 p-3 hover:font-medium md:flex justify-between items-center bg-white lg:px-4 xl:px-8 py-4 rounded-[0.5rem] mb-2">
                                    <div className="flex mb-4 items-center md:mb-0 gap-2">
                                        <img
                                            src={GreenDotIcon}
                                            width={10}
                                            height={10}
                                            alt="green dot icon"
                                            className=""
                                        />
                                        <h3 className="text-[0.875rem] text-[#0C4654] font-[500]">
                                            ORD {uploadedPdfResult?.id}
                                            {`  (${moment(uploadedPdfResult?.uploadedAt).format("Do MMM, YYYY")})`}
                                        </h3>
                                    </div>
                                    <div className="flex flex-col md:flex-row md:items-center gap-2">
                                        <BaseButton
                                            text="View Result"
                                            variant="primary"
                                            styles=" px-4 !h-10 font-[500] xl:w-full xl:!px-8"
                                            click={() =>
                                                viewResult(
                                                    uploadedPdfResult?.url
                                                )
                                            }
                                        ></BaseButton>
                                        <BaseButton
                                            click={() =>
                                                handleDownload(
                                                    uploadedPdfResult?.url
                                                )
                                            }
                                            text="Download"
                                            hasRightIcon={true}
                                            variant="neutral"
                                            styles="text-[#525256] !text-[1rem] border-0 !bg-[#F2F6FA] !px-8 font-[500]"
                                        >
                                            <img
                                                src={DownloadIcon}
                                                alt="green dot icon"
                                                className="w-[20px] ml-2"
                                            />
                                        </BaseButton>
                                    </div>
                                </div>
                            )
                        )
                    )}
                </div>
            </div>

            {/* <ViewResultModal
                record={resultUrl}
                isResultOpen={show}
                closeModal={viewResult}
            /> */}
        </>
    );
};

export default OrganisationDashboardResult;
